// @mui
import { styled } from '@mui/material/styles';
import { CardActionArea, IconButton, Grid, RadioGroup, Typography } from '@mui/material';
// hooks
import useSettings from '../../../hooks/useSettings';
import useLocales from 'src/hooks/useLocales';

// ----------------------------------------------------------------------

const BoxStyle = styled(CardActionArea)(({ theme }) => ({
  height: 40,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // padding: theme.spacing(0.5),
  color: theme.palette.text.disabled,
  // backgroundColor: theme.palette.background.neutral,
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
  border: `solid 1px ${theme.palette.grey[500_12]}`,
}));

// ----------------------------------------------------------------------

export default function SettingDateFormat() {
  const { translate } = useLocales();
  const { dateFormat, onChangeDateFormat } = useSettings();
  const dateFormatValue = ['Qamary', 'Shamsi', 'GD'];
  // const dateFormatValue = [
  //   `${translate('Setting.Qamary')}`,
  //   `${translate('Setting.Shamsi')}`,
  //   `${translate('Setting.GD')}`,
  // ];

  const handleNumberClick = (number: string) => {
    onChangeDateFormat(number);
  };
  return (
    <RadioGroup name="dateFormat" value={dateFormat} onChange={onChangeDateFormat}>
      <Grid dir="ltr" container spacing={1.5}>
        {/* <div style={{ display: 'flex', flexDirection: 'row', gap: '1.5px' }}> */}
        {dateFormatValue.map((value) => {
          const isSelected = value === dateFormat;
          return (
            <Grid key={value} item xs={4}>
              <BoxStyle
                sx={{
                  ...(isSelected && {
                    color: 'primary.main',
                    // bgcolor: alpha(dateFormat, 0.08),
                    border: `solid 2px`,
                    boxShadow: (theme) => theme.customShadows.z20,
                  }),
                }}
              >
                <IconButton
                  // sx={{ borderRadius: '50%', bgcolor: 'default' }}
                  size="small"
                  key={value}
                  onClick={() => handleNumberClick(value)}
                  color={isSelected ? 'primary' : 'default'}
                  style={{
                    // backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.05)' : 'transparent',
                    color: isSelected ? 'primary' : 'default',
                  }}
                >
                  {/* <Typography variant="body2">
                    {value === 'GD'
                      ? `${translate('Setting.GD')}`
                      : value === 'Qamary'
                      ? `${translate('Setting.Qamary')}`
                      : `${translate('Setting.Shamsi')}`}
                  </Typography> */}
                  <Typography variant="body2">
                    {value === 'GD' ? 'GD' : value === 'Qamary' ? 'Qamary' : 'Shamsi'}
                  </Typography>

                  {/* <BoxMask value={value} /> */}
                </IconButton>
              </BoxStyle>
            </Grid>
          );
        })}
        {/* </div> */}
      </Grid>
    </RadioGroup>
  );
}
